import React, { useState, useRef, useEffect, useMemo } from "react"
import { Card, CardBody, Col, Container, Row, DropdownToggle, DropdownItem, DropdownMenu, } from "reactstrap";
import { CascadeSelect } from 'primereact/cascadeselect';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from 'primereact/fileupload';
import { InputText } from "primereact/inputtext";
import { Toast } from 'primereact/toast';
import { confirmDialog } from 'primereact/confirmdialog';
import { getCookie } from "../../helpers/cookie"
import axios from "axios";

const MoreACcompanies = ({ 
    selectedCompanies = [], 
    onDeleteCompanies = () => {}, 
    onAttachDocuments = () => {}, 
    onChangeStatus = () => {},
    toast 
}) => {
const token = getCookie('access_token');
 const fileUploadRef = useRef(null);
    // change status
    const [changeStatusAction, setChangeStatusAction] = useState(false)
    const [isAttachDocumentVisible, setIsAttachDocumentVisible] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState('');

    const [selectedLinkJob, setSelectedLinkJob] = useState(null)
    
    // Handle delete action
    const handleDelete = () => {
        if (selectedCompanies.length === 0) {
            toast?.current?.show({
                severity: 'warn',
                summary: 'No Selection',
                detail: 'Please select companies to delete.'
            });
            return;
        }
        setShowDeleteConfirm(true);
    };

    const confirmDelete = () => {
        onDeleteCompanies(selectedCompanies);
        setShowDeleteConfirm(false);
    };

    const moreoptions = [
        {
            name: "Attachments",
            onClick: () => {
                if (selectedCompanies.length === 0) {
                    toast?.current?.show({
                        severity: 'warn',
                        summary: 'No Selection',
                        detail: 'Please select companies to attach documents.'
                    });
                    return;
                }
                setIsAttachDocumentVisible(true);
            }
        },
        {
            name: "Change Status",
            onClick: () => {
                if (selectedCompanies.length === 0) {
                    toast?.current?.show({
                        severity: 'warn',
                        summary: 'No Selection',
                        detail: 'Please select companies to change status.'
                    });
                    return;
                }
                setChangeStatusAction(true);
            }
        },
        {
            name: "Delete",
            onClick: handleDelete
        },
    ]

    const [selectedDocumentType, setSelectedDocumentType] = useState(null);
    const [documentTypes,setdocumenttypes]= useState('')
    const getDoctType = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/lookups/?name=contact_document_type`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            if (response.status===200) {
                    const options = response.data.results.results.map((category) => ({
            name: category.value
                .replace(/_/g, ' ')
                .replace(/\b\w/g, (char) => char.toUpperCase()),
            code: category.id,
            }));
            setdocumenttypes(options);
            }
        } catch (err) {
            console.log(err);

        }
    }
    useEffect(()=>
    {
        getDoctType()
    },[])

    const [uploadedFiles, setUploadedFiles] = useState([]);
    
    // Status options
    const statusOptions = [
        { name: "Active", code: "active" },
        { name: "Inactive", code: "inactive" },
        { name: "Hold", code: "hold" },
        { name: "Blacklisted", code: "blacklisted" },
    ];

    const onUpload = (event) => {
        // Store the uploaded files in state
        setUploadedFiles((prevFiles) => [...prevFiles, ...event.files]);
    };
    
    // Handle file selection (without uploading to server)
    const onSelect = (event) => {
        // Store the selected files in state
        setUploadedFiles((prevFiles) => [...prevFiles, ...event.files]);
    };

    // Custom upload handler
    const customUploadHandler = (event) => {
        // Just store the files, don't upload to server
        setUploadedFiles((prevFiles) => [...prevFiles, ...event.files]);
        
        // Show success message
        toast?.current?.show({
            severity: 'success',
            summary: 'Files Selected',
            detail: `${event.files.length} file(s) selected successfully.`
        });
    };

    const [docSubject, setDocSubject] = useState("");

    // Handle status change submission
    const handleStatusChange = () => {
        if (!selectedStatus) {
            toast?.current?.show({
                severity: 'warn',
                summary: 'No Status Selected',
                detail: 'Please select a status to change.'
            });
            return;
        }
        
        onChangeStatus(selectedCompanies, selectedStatus);
        setChangeStatusAction(false);
        setSelectedStatus('');
    };

    // Handle document attachment
    const handleAttachDocuments = () => {
        if (!selectedDocumentType || !docSubject || uploadedFiles.length === 0) {
            toast?.current?.show({
                severity: 'warn',
                summary: 'Missing Information',
                detail: 'Please fill all required fields and upload at least one document.'
            });
            return;
        }

        const attachmentData = {
            documentType: selectedDocumentType,
            subject: docSubject,
            files: uploadedFiles
        };

        onAttachDocuments(selectedCompanies, attachmentData);
        
        // Reset form
        setSelectedDocumentType(null);
        setDocSubject("");
        setUploadedFiles([]);
        setIsAttachDocumentVisible(false);
    };
    const handleCloseDialog = () => {
    setIsAttachDocumentVisible(false);
    setUploadedFiles([]);
    setSelectedDocumentType(null);
    setDocSubject("");
  }
    const handleSubnit = async () => {
        try {
            const value = selectedCompanies[0]?.id
            const formData = new FormData()
            formData.append('type', selectedDocumentType?.code)
            formData.append('description', docSubject)
            if (uploadedFiles instanceof File) {
                formData.append('uploaded_files', uploadedFiles);
            }
            else if (Array.isArray(uploadedFiles)) {
                uploadedFiles.forEach((file, idx) => {
                    formData.append('uploaded_files', file);
                });
            }
            const response = await axios.post(`${process.env.REACT_APP_Company_Contact}/company/companies/${value}/documents/`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            if (response.status === 201) {
                toast.current && toast.current.show({ severity: 'success', summary: 'Added', detail: 'Document Added Successfully' })
                setIsAttachDocumentVisible(false)
                setUploadedFiles(null)
                setDocSubject("")
                setSelectedDocumentType('')
            }
        } catch (err) {
            console.log(err);

        }
    }

    return (
        <React.Fragment>

            <CascadeSelect
                value={selectedLinkJob}
                onChange={(e) => {
                    if (e.value && e.value.onClick) {
                        e.value.onClick();
                    }
                }}
                options={moreoptions}
                optionLabel="name"
                optionGroupLabel="name"
                optionGroupChildren={["jobs"]}
                placeholder="More"
                className="me-1"
            />

            {/* change status starts */}
            <Dialog
                header="Change Status"
                visible={changeStatusAction}
                onHide={() => setChangeStatusAction(false)}
                style={{ width: '30vw' }}
                className="changestatus-popup"
            >
                <div className="p-fluid">
                    <Row className="mt-2 align-items-center">
                        <Col xl={12}>
                            <label className="block mb-2">
                                Status for {selectedCompanies.length} selected companies
                            </label>
                            <Dropdown
                                value={selectedStatus}
                                onChange={(e) => setSelectedStatus(e.value)}
                                options={statusOptions}
                                optionLabel="name"
                                optionValue="code"
                                placeholder="Select Status"
                                className="w-full"
                            />
                        </Col>
                    </Row>

                    <div className="d-flex justify-content-end gap-2 mt-4">
                        <Button 
                            label="Cancel" 
                            icon="pi pi-times" 
                            outlined 
                            onClick={() => {
                                setChangeStatusAction(false);
                                setSelectedStatus('');
                            }} 
                        />
                        <Button 
                            label="Submit" 
                            icon="pi pi-check" 
                            onClick={handleStatusChange}
                        />
                    </div>
                </div>
            </Dialog>


            {/* attachements starts */}
            {/* <Dialog
                header="Attachments"
                visible={isAttachDocumentVisible}
                onHide={() => setIsAttachDocumentVisible(false)}
                style={{ width: '45vw' }}
                breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            >
                <div className="p-fluid">
                    <div className="mb-3">
                        <p className="text-muted mb-3">
                            Attaching documents to {selectedCompanies.length} selected companies
                        </p>
                    </div>
                    
                    <Row className="align-items-center">
                        <Col xl={6}>
                            <div className="p-field mb-3">
                                <label className="block mb-2">
                                    Document Type *
                                </label>
                                <Dropdown
                                    value={selectedDocumentType}
                                    onChange={(e) => setSelectedDocumentType(e.value)}
                                    options={documentTypes}
                                    optionLabel="name"
                                    placeholder="Select a Document Type"
                                    className="w-full"
                                />
                            </div>
                        </Col>

                        <Col lg={6}>
                            <div className="p-field mb-3">
                                <label htmlFor="docSubject" className="block mb-2">Document Subject *</label>
                                <InputText
                                    id="docSubject"
                                    value={docSubject}
                                    onChange={(e) => setDocSubject(e.target.value)}
                                    placeholder="Enter Document Subject"
                                    className="w-full"
                                />
                            </div>
                        </Col>

                        <Col lg={12}>
                            <div className="p-field mb-3">
                                <label className="block mb-2">
                                    Attach Documents *
                                </label>
                                <FileUpload 
                                    name="demo[]" 
                                    multiple 
                                    maxFileSize={10000000} // 10MB
                                    customUpload={true}
                                    uploadHandler={customUploadHandler}
                                    onSelect={onSelect}
                                    chooseLabel="Choose Files"
                                    uploadLabel="Add Files"
                                    cancelLabel="Clear"
                                    emptyTemplate={<p className="text-center">Drag and drop files here or click to browse.</p>}
                                />
                            </div>
                        </Col>
                    </Row>
                    
                    <div className="d-flex justify-content-end gap-2 mt-4">
                        <Button 
                            label="Cancel" 
                            icon="pi pi-times" 
                            outlined 
                            onClick={() => {
                                setIsAttachDocumentVisible(false);
                                setSelectedDocumentType(null);
                                setDocSubject("");
                                setUploadedFiles([]);
                            }} 
                        />
                        <Button 
                            label="Submit" 
                            icon="pi pi-check" 
                            onClick={handleAttachDocuments}
                        />
                    </div>
                </div>
            </Dialog> */}
            <Dialog
                header="Attachments"
                visible={isAttachDocumentVisible}
                onHide={handleCloseDialog}
                style={{ width: '45vw' }}
                breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            >
                <Row className="align-items-center">
                    <Col xl={6}>
                        <div className="card flex justify-content-center mb-0 border-0">
                            <label className="block mb-2">
                                Document Type
                            </label>
                            <Dropdown
                                value={selectedDocumentType}
                                onChange={(e) => setSelectedDocumentType(e.value)}
                                options={documentTypes}
                                optionLabel="name"
                                placeholder="Select a Document Type"
                                className="w-full bgclr"
                            />
                        </div>
                    </Col>

                    <Col lg={6}>
                        <div className="p-field mt-2">
                            <label htmlFor="docSubject" className="block">Document Subject</label>
                            <InputText
                                id="docSubject"
                                value={docSubject}
                                onChange={(e) => setDocSubject(e.target.value)}
                                placeholder="Enter Document Subject"
                                className="p-inputtext-sm w-full"
                            />
                        </div>
                    </Col>

                    <Col lg={12}>
                        <div className="card flex justify-content-center mb-0 border-0 mt-2">
                            <label className="block mb-2">
                                Attach Documents
                            </label>
                            <FileUpload
                                ref={fileUploadRef}
                                name="files[]"
                                accept="image/jpg,image/jpeg,image/png,application/pdf"
                                maxFileSize={1000000}
                                multiple
                                customUpload
                                auto
                                uploadHandler={(e) => {
                                    setUploadedFiles(e.files)
                                }}
                                onClear={() => {
                                    console.log("Files cleared")
                                    setUploadedFiles([])
                                }}
                            />
                        </div>
                    </Col>

                    <Col lg={12}>
                        <button
                            className="btn btn-primary btn-main mt-2"
                            onClick={handleSubnit}
                        >
                            Submit
                        </button>
                    </Col>
                </Row>
            </Dialog>
            {/* Delete Confirmation Dialog */}
            <Dialog
                header="Confirm Deletion"
                visible={showDeleteConfirm}
                onHide={() => setShowDeleteConfirm(false)}
                style={{ width: '400px' }}
            >
                <div className="p-fluid">
                    <p>
                        Are you sure you want to delete {selectedCompanies.length} selected companies? 
                        This action cannot be undone.
                    </p>
                    
                    <div className="d-flex justify-content-end gap-2 mt-4">
                        <Button 
                            label="Cancel" 
                            icon="pi pi-times" 
                            outlined 
                            onClick={() => setShowDeleteConfirm(false)} 
                        />
                        <Button 
                            label="Delete" 
                            icon="pi pi-trash" 
                            severity="danger"
                            onClick={confirmDelete}
                        />
                    </div>
                </div>
            </Dialog>

        </React.Fragment>
    );
};



export default MoreACcompanies;